import {Fragment, useState} from 'react' ;
import Button from 'react-bootstrap/Button' ;
import Form from 'react-bootstrap/Form' ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' ;
import { faPenToSquare, faEye, faTrash } from '@fortawesome/free-solid-svg-icons' ;

import {DisplayElement, TableCell} from './TableComps.js' ;
import './gtable.css' ;

const TableRow = ({sno, rowData, columns, actions, selected, setSelected, setSideMenu, display, editData}) => {
	const [active, setActive] = useState(true) ;
	const [checked, setChecked] = useState(false) ;

	const toggleActive = () => setActive(!active) ;	
	const toggleCheckBox = () => setChecked(!checked) ;	

	const onSwitchClick = (event) => {
		toggleActive() ;
		actions['switch'](event) ;
	}

	const onCheckBoxClick = (event) => {
		toggleCheckBox() ;
		const contains = selected.filter(one => one !== event.target.ariaLabel) ;
		if(selected.length === contains.length)
			setSelected([...selected, event.target.ariaLabel]) ;
		else
			setSelected(contains) ;
	}

	const onViewClick = () => {
		console.log(rowData) ;
		if(display)
			setSideMenu(display.map((dis, i)=> <DisplayElement key={i} dis={dis} data={rowData[dis.name]} />)) ;
	}

	
	const createTableComps = (one, sno) => {
		const tableComps = {
			sno: <td onClick={actions['sno']}>{sno}</td>,
			view: <td onClick={onViewClick}><FontAwesomeIcon className="gtable-icon gtable-eye" icon={faEye} /></td>,
			checkbox: <td><Form.Check aria-label={one+sno} onChange={onCheckBoxClick} checked={checked}/></td>,
			delete: <td ><FontAwesomeIcon className="gtable-icon gtable-trash" icon={faTrash} /></td>,
			edit: <td ><FontAwesomeIcon className="gtable-icon gtable-pen" icon={faPenToSquare} /></td>,
			switch: <td><Form.Check aria-label={one+sno} type="switch" checked={active} onChange={onSwitchClick}/></td>,
			cancel: <td onClick={actions['cancel']}><Button variant="danger">Cancel</Button></td>,
		}

		return tableComps[one] ;
	}

	return (
		<tr>
			{actions.before.map((one, i) => <Fragment key={i}>{createTableComps(one, sno)}</Fragment>)}
			{columns.map((col, i)=> <TableCell key={i} col={col} cellData={rowData[col.name]} />)}
			{actions.after.map((one, i) => <Fragment key={i}>{createTableComps(one, sno)}</Fragment>)}
		</tr>
	) ;
}

export default TableRow ;